import { render, staticRenderFns } from "./DsoChart.vue?vue&type=template&id=f2d52a5e"
import script from "./DsoChart.vue?vue&type=script&lang=ts"
export * from "./DsoChart.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports